import React from "react"
import Wrapper from "@components/Wrapper"
import WrapperInner from "@components/WrapperInner"
import styles from "./Message.module.scss"
import AnchorButton from "@components/AnchorButton"

const Message = props => {
  return (
    <section className="container-fluid bg-lg-gray bg-xl-light-gray">
      <div className="row ml-0 mr-0">
        <Wrapper className="w-100 text-center text-lg-left" gap="outer">
          <WrapperInner className={styles.wrapperInner + " bg-info row"}>
            <p className="col-12 text-white mb-6 fs-18pt col-lg-6 col-xl-7 pr-0">
              <span className="proxima-nova--light">
                We've done the hard work to integrate with the common
                cloud-based Applications.{" "}
              </span>
              <span className="proxima-nova--bold d-inline-block">
                You simply plug them into your EngineID account and set up your
                access parameters.
              </span>
            </p>
            <div className="col-12 col-lg-6 col-xl-5 text-lg-center">
              <AnchorButton
                className={styles.button}
                href="/demo"
                content="SEE A DEMO"
                contentClassName="text-middle"
              />
            </div>
          </WrapperInner>
        </Wrapper>
      </div>
    </section>
  )
}

export default Message
